module.exports = __webpack_public_path__ + "52de2fa392d2a073e985eec7f3852192.pdf";